import React, { useEffect, useState } from "react";
import Styles from "./style.module.scss";
import InputField from "@Molecule/InputField";
import CSPersonImg from "@Assets/Images/poni-cs.webp";
import { Alert, Button, Snackbar } from "@mui/material";
import { propspectiveClientContact } from "@Services/support/candidate";
import Spinner from "@Atom/Spinner";

export default function FormContactUs() {
  const [inputForm, setInputForm] = useState({
    name: "",
    email: "",
    telephone: "",
    companyName: "",
    position: "",
  });

  const handleChangeForm = (e, name) => {
    if (name === "telephone") {
      setInputForm((prev) => ({
        ...prev,
        [name]: e?.target.value?.replace(/[^\d.+]/gi, ""),
      }));
    } else
      setInputForm((prev) => ({
        ...prev,
        [name]: e?.target.value,
      }));
  };

  const isDisabledButton = () => {
    const { companyName, email, name, telephone, position } = inputForm;
    if (!name || !email || !telephone || !companyName || !position) return true;
    return false;
  };

  const [isSuccessPost, setIsSuccessPost] = useState(false);
  const [isLoadingPost, setIsLoadingPost] = useState(false);
  const handleSubmitToContact = async () => {
    const {
      companyName: clientName,
      email,
      name,
      telephone,
      position,
    } = inputForm;
    setIsSuccessPost(false);
    setIsLoadingPost(true);
    try {
      const dataToSend = {
        name,
        email,
        phoneNumber: telephone?.split("+").join(""),
        clientName,
        position,
      };
      await propspectiveClientContact(dataToSend);
      setIsSuccessPost(true);
      setInputForm({
        name: "",
        email: "",
        telephone: "",
        companyName: "",
        position: "",
      });
    } catch (error) {
      console.error("Error", error);
      setIsSuccessPost("error");
    } finally {
      setIsLoadingPost(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (isSuccessPost) {
        setIsSuccessPost(false);
      }
    }, 3000);
  }, [isSuccessPost]);

  return (
    <div className={Styles.sectionFormContactUs} id="contact-us-form">
      <div className={Styles.leftSection}>
        <img src={CSPersonImg} alt="cs-person" />
      </div>
      <Snackbar
        open={isSuccessPost}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        onClose={() => setIsSuccessPost(false)}
      >
        <Alert
          onClose={() => setIsSuccessPost(false)}
          severity={isSuccessPost === "error" ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {isSuccessPost === "error"
            ? "Gagal mengirimkan form"
            : "Berhasil mengirimkan form"}
        </Alert>
      </Snackbar>
      <div className={Styles.right}>
        <div className={Styles.headerForm}>
          <p>Tertarik untuk menggunakan sistem kami?</p>
          <h2>Hubungi Kami Sekarang Juga!</h2>
        </div>
        <div>
          <InputField
            onChange={(e) => handleChangeForm(e, "name")}
            value={inputForm.name}
            title={"Nama Lengkap"}
            placeholder="Masukkan Nama Anda"
          />
        </div>
        <div>
          <InputField
            onChange={(e) => handleChangeForm(e, "email")}
            value={inputForm.email}
            title={"Email"}
            placeholder="Masukkan Email Anda"
            isEmail
          />
        </div>
        <div>
          <InputField
            onChange={(e) => handleChangeForm(e, "telephone")}
            isPhoneNumber
            value={inputForm.telephone}
            title={"No Whatsapp"}
            placeholder="+62"
          />
        </div>
        <div>
          <InputField
            onChange={(e) => handleChangeForm(e, "companyName")}
            value={inputForm.companyName}
            title={"Nama Perusahaan"}
            placeholder="Masukkan nama instansi perusahaan"
          />
        </div>
        <div>
          <InputField
            onChange={(e) => handleChangeForm(e, "position")}
            value={inputForm.position}
            title={"Jabatan"}
            placeholder="Jabatan Anda di perusahaan sekarang"
            labelColor={""}
            color={"red"}
          />
        </div>
        <div className={Styles.btnSend}>
          <Button
            onClick={(e) => (isLoadingPost ? {} : handleSubmitToContact(e))}
            variant="contained"
            className={Styles.btn}
            disabled={isDisabledButton()}
          >
            <span>{isLoadingPost ? "Mengirim form" : "Kirim Sekarang"}</span>
            {isLoadingPost && <Spinner />}
          </Button>
        </div>
      </div>
    </div>
  );
}
